import './lib/sentry';
import React from 'react';
import ReactDOMClient from 'react-dom/client';
import { App } from '~/components/root/App';
import './index.css';

const container = document.getElementById('root') as HTMLElement;
const root = ReactDOMClient.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
